/**
 * Web analytics tracker'ini site ayarlarina gore baslatir.
 *
 * Iki giris noktasi ayni fonksiyonu kullanir:
 *  - static/scripts.js (loader.js): web chat + tracking birlikte
 *  - static/tracker.js (tracker.js): yalnizca tracking, chat balonu yuklenmez
 *
 * settings.webAnalytics plan ozelligi kapaliysa false gelir (bkz. tablet getAllSettingsAsPublic).
 */
import log2 from "../js/log2-lite";
import { buildUrl } from "./utils";
import { CONFIG as APP_CONFIG } from "../../src/utils/config";
import tracker from "./tracker";
import trackerEditor, { readNonce } from "./tracker/editor";

const log = log2("AnalyticsBoot");

export function initWebAnalytics(site, settings) {
    try {
        const config = settings && settings.webAnalytics;
        if (!config) {
            log.debug("web analytics disabled for site");
            return false;
        }

        // Event builder editor modu: kural yazarken sayfadan element secmek ve
        // kaydedilmemis kurallari denemek icin panel bu adresi `?supsis-editor=NONCE` ile acar.
        // Site kendi izlemesini kapatmis olsa da editor calisir (veri gonderilmez).
        if (readNonce()) trackerEditor.start(tracker, site._id);

        if (config.enabled === false) {
            log.debug("web analytics disabled by site setting");
            return false;
        }

        tracker.init({
            siteId: site._id,
            endpoint: APP_CONFIG.TRACK_URL,
            // Sayfa kayit defteri ayri endpoint/topic kullanir; durum sorgusu CDN'den gelir
            pageEndpoint: APP_CONFIG.TRACK_PAGE_URL,
            pageStatusUrl: buildUrl("public/web-analytics/page-status"),
            settings: config,
        });
        return true;
    } catch (e) {
        // Analitik baslatilamazsa widget akisi etkilenmemeli
        log.error("initWebAnalytics failed", e);
        return false;
    }
}

export default initWebAnalytics;



//////////////////
// WEBPACK FOOTER
// ./static/src/analyticsBoot.js
// module id = null
// module chunks = 